// @flow

import React, { Component } from "react";

function RequireLoggedIn(WrappedComponent: Class<React.Component<*, *>>) {
  return class extends Component<*> {
    isLoggedIn() {
      return this.props.userData && this.props.userData.user;
    }

    render() {
      return (
        <div>
          {this.isLoggedIn() ? (
            <WrappedComponent {...this.props} />
          ) : (
            <p> Loading... </p>
          )}
        </div>
      );
    }
  };
}

export default RequireLoggedIn;



// WEBPACK FOOTER //
// ./src/components/RequireLoggedIn/RequireLoggedIn.js